import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/freightsource.css'
import App from './App.jsx'
import { BugTracker } from './lib/bugtracker.js'
import { getBugtrackerUser } from './lib/bugtrackerUser.js'

if (import.meta.env.VITE_BUGTRACKER_KEY) {
  BugTracker.init({
    endpoint: import.meta.env.VITE_BUGTRACKER_ENDPOINT || 'https://bugtracker.crudmonkey.co.uk',
    apiKey: import.meta.env.VITE_BUGTRACKER_KEY,
    app: 'freightsource',
    environment: import.meta.env.MODE,
    getUser: getBugtrackerUser,
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
